import React, {
  useState, useEffect, useRef, useImperativeHandle,
} from 'react';

import parse from 'html-react-parser';
import { historicoProcessoController } from './historicoProcessoController';
import { tipoExibicaoHistorico } from '../../../models/types';
import {
  Checkbox,
  Container,
  Content,
  DateIndicator,
  Loading,
  VerticalLine,
} from './HistoricoProcesso.styles';
import { colocarTagEmString } from '../../../helpers';

function getDateIndicator(date) {
  return date.replace(/^[0-9]+\?/, '');
}

function isEndOfScroll(target, historicos) {
  const { scrollTop, clientHeight, scrollHeight } = target;
  const acceptedInterval = 30;
  return ((scrollTop + clientHeight) >= (scrollHeight - acceptedInterval)) && historicos && !historicos.last;
}

export function HistoricoProcessoComponent({
  historicos = {},
  addNextHistoricos,
  showLoading,
  isDisbaledChangePin = false,
  onChangeChecked = () => { },
  height = 512,
}, ref) {
  const [content, setContent] = useState({});
  const historicosRef = useRef();

  function onScrollHandler(e) {
    if (isEndOfScroll(e.currentTarget, historicos)) {
      addNextHistoricos();
    }
  }

  function scrollToTop() {
    if (historicosRef.current) {
      historicosRef.current.scrollTop = 0;
    }
  }

  useImperativeHandle(ref, () => ({
    scrollToTop,
  }));

  function formatacaoAcordoHistorico(formTexto) {
    if (formTexto.substr(0, 10) === 'Simulação:') {
      let textoFormatado = colocarTagEmString(formTexto, 'Taxas: Juros: ', 'strong');
      textoFormatado = colocarTagEmString(textoFormatado, 'Valor Total do Acordo: ', 'strong');
      textoFormatado = colocarTagEmString(textoFormatado, 'Acordo: ', 'strong');
      textoFormatado = colocarTagEmString(textoFormatado, 'Sequência dos Títulos negociados: ', 'strong');
      textoFormatado = colocarTagEmString(textoFormatado, 'Total de Parcelas: ', 'strong');
      textoFormatado = colocarTagEmString(textoFormatado, '- Honorários: ', 'strong');
      textoFormatado = colocarTagEmString(textoFormatado, '- Descontos: ', 'strong');
      textoFormatado = colocarTagEmString(textoFormatado, '- Parcelas: ', 'strong');
      textoFormatado = colocarTagEmString(textoFormatado, 'Valor Total da Simulação: ', 'strong');
      textoFormatado = colocarTagEmString(textoFormatado, 'Simulação:', 'strong');
      return textoFormatado;
    }
    if (formTexto.substr(0, 7) === 'Acordo:') {
      let textoFormatado = colocarTagEmString(formTexto, 'Taxas: Juros: ', 'strong');
      textoFormatado = colocarTagEmString(textoFormatado, 'Sequência dos Títulos negociados: ', 'strong');
      textoFormatado = colocarTagEmString(textoFormatado, 'Valor Total do Acordo: ', 'strong');
      textoFormatado = colocarTagEmString(textoFormatado, 'Acordo: ', 'strong');
      textoFormatado = colocarTagEmString(textoFormatado, 'Total de Parcelas: ', 'strong');
      textoFormatado = colocarTagEmString(textoFormatado, '- Honorários: ', 'strong');
      textoFormatado = colocarTagEmString(textoFormatado, '- Descontos: ', 'strong');
      textoFormatado = colocarTagEmString(textoFormatado, '- Parcelas: ', 'strong');
      textoFormatado = colocarTagEmString(textoFormatado, 'Valor Total do Acordo: ', 'strong');
      textoFormatado = colocarTagEmString(textoFormatado, 'Acordo:', 'strong');
      return textoFormatado;
    }
    if (formTexto.substr(0, 13) === 'Simulação nº ') {
      let textoFormatado = colocarTagEmString(formTexto, 'Taxas: Juros: ', 'strong');
      textoFormatado = colocarTagEmString(textoFormatado, 'Sequência dos Títulos negociados: ', 'strong');
      textoFormatado = colocarTagEmString(textoFormatado, 'Valor Total do Acordo: ', 'strong');
      textoFormatado = colocarTagEmString(textoFormatado, 'Acordo: ', 'strong');
      textoFormatado = colocarTagEmString(textoFormatado, 'Total de Parcelas: ', 'strong');
      textoFormatado = colocarTagEmString(textoFormatado, '- Honorários: ', 'strong');
      textoFormatado = colocarTagEmString(textoFormatado, '- Descontos: ', 'strong');
      textoFormatado = colocarTagEmString(textoFormatado, '- Parcelas: ', 'strong');
      textoFormatado = colocarTagEmString(textoFormatado, 'Valor Total do Acordo: ', 'strong');
      textoFormatado = colocarTagEmString(textoFormatado, 'Acordo:', 'strong');
      return textoFormatado;
    }
    if (formTexto.substr(0, 33) === 'Simulação aguardando aprovação de') {
      let textoFormatado = colocarTagEmString(formTexto, 'Simulação aguardando aprovação de ', 'strong');
      textoFormatado = colocarTagEmString(textoFormatado, '- Motivos: ', 'strong');
      textoFormatado = colocarTagEmString(textoFormatado, '- Motivo: ', 'strong');
      textoFormatado = colocarTagEmString(textoFormatado, '- Sequência dos Títulos negociados: ', 'strong');
      textoFormatado = colocarTagEmString(textoFormatado, '- Taxas: Juros: ', 'strong');
      textoFormatado = colocarTagEmString(textoFormatado, '- Honorários:', 'strong');
      textoFormatado = colocarTagEmString(textoFormatado, '- Descontos: ', 'strong');
      textoFormatado = colocarTagEmString(textoFormatado, '- Total de Parcelas: ', 'strong');
      textoFormatado = colocarTagEmString(textoFormatado, '- Parcelas: ', 'strong');
      textoFormatado = colocarTagEmString(textoFormatado, '- Valor Total do Acordo: ', 'strong');
      return textoFormatado;
    }
    return formTexto;
  }


  useEffect(() => {
    if (historicos && historicos.content) {
      setContent(historicoProcessoController.makeItems(historicos.content));
    } else {
      setContent(historicoProcessoController.makeItems());
    }
  }, [historicos]);

  return (
    <Container height={height}>
      <Loading show={showLoading}>
        Carregando...
      </Loading>
      <VerticalLine />
      <div ref={historicosRef} className="wrapper" onScroll={onScrollHandler}>
        {Object.keys(content).map(data => (
          <ul key={data}>
            <DateIndicator>{getDateIndicator(data)}</DateIndicator>
            {
              content[data].map(historico => (
                <Content
                  key={historico.key}
                  type={historico.idTipoHistorico}
                >
                  <div>
                    <Checkbox
                      type={historico.idTipoHistorico}
                      unchangedPin={historico.fixar === tipoExibicaoHistorico.fixoSistema}
                    >
                      {historico.descricaoTipo === 'Instrução' ? (
                        <input
                          type="checkbox"
                          name={historico.idProcessoHistorico}
                          disabled
                          defaultValue={historico.fixar}
                          defaultChecked={historico.fixar === tipoExibicaoHistorico.fixoSistema || historico.fixar === tipoExibicaoHistorico.fixo}
                          onChange={onChangeChecked}
                        />
                      )
                        : (
                          <input
                            type="checkbox"
                            name={historico.idProcessoHistorico}
                            disabled={historico.fixar === tipoExibicaoHistorico.fixoSistema || isDisbaledChangePin}
                            defaultValue={historico.fixar}
                            defaultChecked={historico.fixar === tipoExibicaoHistorico.fixoSistema || historico.fixar === tipoExibicaoHistorico.fixo}
                            onChange={onChangeChecked}
                          />
                        )
                      }
                      <span className="checkmark" />
                    </Checkbox>
                    {historico.dataHora && (
                      <p>
                        <span>Data: </span>
                        {historico.dataHora}
                      </p>
                    )}
                    {historico.usuario && (
                      <p>
                        <span>Autor: </span>
                        {historico.usuario}
                      </p>
                    )}
                    {historico.faseAtualProcesso && (
                      <p>
                        <span>Fase Atual: </span>
                        {historico.faseAtualProcesso}
                      </p>
                    )}
                    {historico.texto && (
                      <pre>
                        <span>
                          {historico.descricaoTipo}
                          :
                          {' '}
                        </span>
                        {parse(formatacaoAcordoHistorico(historico.texto))}
                      </pre>
                    )}
                    {historico.faseSeguinteProcesso && (
                      <p>
                        <span>Enviado para: </span>
                        {historico.faseSeguinteProcesso}
                      </p>
                    )}
                  </div>
                </Content>
              ))
            }
          </ul>
        ))}
      </div>
    </Container>
  );
}


export const HistoricoProcesso = React.forwardRef(HistoricoProcessoComponent);
